module.exports = __webpack_public_path__ + "static/react-83e57a9da4e2a7b7e187bed56665388d.png";